<template>
  <div class="landing">
    <!-- NAVBAR -->

    <nav class="navbar navbar-expand-lg navbar-dark fixed-top nav-glass">
      <div class="container">
        <div class="footer-brand1">
          <div class="brand-logo">Logic<span>Line</span></div>
        </div>
        <div class="small">Engineering the Future, One Line of Logic at a Time</div>

        <!-- <div class="ms-auto">
          <router-link to="/login" class="btn btn-login"> ورود </router-link>
        </div> -->
      </div>
    </nav>

    <!-- HERO -->

    <section class="hero">
      <div class="hero-glow"></div>

      <div class="container text-center hero-content">
        <h1 class="hero-title">سیستم مدیریت هوشمند آموزشگاه زبان</h1>
        <h3 class="mt-5">آموزشگاهت رو هوشمند مدیریت کن</h3>
        <p class="hero-sub">یه پلتفرم یکپارچه برای مدیریت زبان‌آموزان، کلاس‌ها، اساتید و امور مالی (سریع، دقیق و بدون پیچیدگی)</p>

        <div class="hero-buttons">
          <span class="btn btn-main" @click="MoshaverTell"> درخواست مشاوره تلفنی </span>
          <router-link to="/login" class="btn btn-outline-main mx-2"> مشاهده دمو </router-link>
        </div>
      </div>
    </section>

    <!-- DASHBOARD MOCK -->
    <!-- 
    <section class="dashboard">
      <div class="container">
        <div class="dashboard-card">
          <div class="row">
            <div class="col-md-3 sidebar">
              <h6>Dashboard</h6>

              <ul>
                <li>دانشجویان</li>
                <li>کلاس‌ها</li>
                <li>اساتید</li>
                <li>گزارش مالی</li>
              </ul>
            </div>

            <div class="col-md-9">
              <div class="row g-3">
                <div class="col-md-4">
                  <div class="stat">
                    <h3>120</h3>
                    <span>زبان آموز</span>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="stat">
                    <h3>18</h3>
                    <span>کلاس فعال</span>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="stat">
                    <h3>9</h3>
                    <span>استاد</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- FEATURES -->

    <!-- FEATURES -->
    <section class="features" id="features">
      <div class="container">
        <div class="text-center mb-5">
          <h2 class="section-title text-dark">همه‌چیز برای مدیریت هوشمند آموزشگاه زبان</h2>
          <p class="section-subtitle text-dark">مجموعه‌ای از امکانات کاربردی که فرایندهای آموزشی، مالی و ارتباطی آموزشگاه شما را یکپارچه و خودکار می‌کند.</p>
        </div>

        <div class="row g-4">
          <!-- Feature -->
          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">🎓</div>
              <h4>مدیریت زبان‌آموزان و اساتید</h4>
              <p>ثبت، دسته‌بندی و مدیریت کامل زبان‌آموزان، اساتید و کلاس‌ها همراه با تاریخچه آموزشی و وضعیت پرداخت</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">📅</div>
              <h4>برنامه‌ریزی کلاس‌ها</h4>
              <p>زمان‌بندی هوشمند کلاس‌ها، تعیین سطح، مدیریت ترم‌ها</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">💳</div>
              <h4>مدیریت مالی و پرداخت‌ها</h4>
              <p>ثبت شهریه، اقساط و گزارش‌گیری دقیق مالی با شفافیت کامل</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">📊</div>
              <h4>گزارش‌گیری و داشبورد مدیریتی</h4>
              <p>گزارش‌های تحلیلی از وضعیت ثبت‌نام، درآمد، عملکرد اساتید و رشد آموزشگاه در یک داشبورد متمرکز.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">📩</div>
              <h4>پنل پیامکی و اطلاع‌رسانی</h4>
              <p>ارسال پیامک خودکار برای ثبت‌نام، یادآوری کلاس‌ها، پرداخت‌ها و اطلاع‌رسانی‌های مهم.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">📱</div>
              <h4>نسخه PWA (اپلیکیشن تحت وب)</h4>
              <p>دسترسی سریع از موبایل و دسکتاپ بدون نیاز به نصب از مارکت‌ها، با تجربه‌ای شبیه اپلیکیشن واقعی.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">🔐</div>
              <h4>امنیت و سطوح دسترسی</h4>
              <p>مدیریت نقش‌ها و دسترسی‌ها برای مدیر، منشی، استاد و کاربران با استانداردهای امنیتی.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">⚙️</div>
              <h4>قابلیت شخصی‌سازی</h4>
              <p>امکان اضافه کردن نیاز های شما در روند امور آموزشگاه</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="feature-card">
              <div class="feature-icon">🔄</div>
              <h4>به‌روزرسانی مداوم سیستم</h4>
              <p>دریافت منظم به‌روزرسانی‌های امنیتی و امکانات جدید بدون اختلال در عملکرد آموزشگاه.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PRICING -->

    <!-- <section class="pricing" id="pricing">
  <div class="container">

    <div class="text-center mb-5">
      <span class="section-badge">تعرفه‌ها</span>
      <h2 class="section-title text-white">مقایسه طرح اقتصادی و حرفه‌ای</h2>
      <p class="section-subtitle text-light">
        بر اساس نوع راه‌اندازی، بودجه و سطح پشتیبانی، طرح مناسب آموزشگاه خود را انتخاب کنید.
      </p>
    </div>

    <div class="row justify-content-center g-4">

      <div class="col-lg-5 col-md-6">
        <div class="price-card">
          <div class="plan-header">
            <h3>طرح اقتصادی</h3>
            <p>نصب روی ساب‌دامنه سیستم — مناسب شروع و آموزشگاه‌های کوچک</p>
          </div>

          <div class="price-main">
            <div class="setup-cost">
              <span class="label">هزینه راه‌اندازی اولیه</span>
              <span class="value">۱۲ میلیون</span>
            </div>

            <div class="billing-options">
              <div class="billing-item">
                <span class="label">اشتراک ماهانه</span>
                <span class="value">۲.۹ میلیون</span>
              </div>
              <div class="billing-item">
                <span class="label">طرح ۳ ماهه</span>
                <span class="value">۸.۵ میلیون</span>
              </div>
              <div class="billing-item">
                <span class="label">طرح ۶ ماهه</span>
                <span class="value">۱۶ میلیون</span>
                <span class="hint">+ ۸۰۰ پیامک هدیه</span>
              </div>
              <div class="billing-item">
                <span class="label">طرح ۱۲ ماهه</span>
                <span class="value">۲۹.۹ میلیون</span>
                <span class="hint">+ ۲۰۰۰ پیامک هدیه</span>
              </div>
            </div>
          </div>

          <ul class="features-list">
            <li><span class="key">برند اختصاصی</span><span class="val muted">ندارد</span></li>
            <li><span class="key">اولویت پشتیبانی</span><span class="val">معمولی</span></li>
            <li><span class="key">محدودیت کاربر</span><span class="val success">ندارد</span></li>
            <li><span class="key">محدودیت امکانات</span><span class="val success">ندارد</span></li>
            <li><span class="key">پنل پیامکی</span><span class="val success">فعال</span></li>
            <li><span class="key">آپدیت امنیتی</span><span class="val success">فعال</span></li>
            <li><span class="key">آپدیت امکانات</span><span class="val success">فعال</span></li>
            <li><span class="key">انتقال اطلاعات</span><span class="val success">رایگان</span></li>
          </ul>

          <button class="btn btn-price-outline w-100">
            انتخاب طرح اقتصادی
          </button>
        </div>
      </div>

      <div class="col-lg-5 col-md-6">
        <div class="price-card featured">
          <div class="featured-badge">پیشنهادی</div>

          <div class="plan-header">
            <h3>طرح حرفه‌ای</h3>
            <p>نصب روی دامنه اختصاصی آموزشگاه — مناسب برندینگ و رشد بلندمدت</p>
          </div>

          <div class="price-main">
            <div class="setup-cost">
              <span class="label">هزینه راه‌اندازی اولیه</span>
              <span class="value">۲۵ میلیون</span>
            </div>

            <div class="billing-options">
              <div class="billing-item">
                <span class="label">اشتراک ماهانه</span>
                <span class="value">۳.۵ میلیون</span>
              </div>
              <div class="billing-item">
                <span class="label">طرح ۳ ماهه</span>
                <span class="value">۹.۹ میلیون</span>
              </div>
              <div class="billing-item">
                <span class="label">طرح ۶ ماهه</span>
                <span class="value">۱۹ میلیون</span>
                <span class="hint">+ ۱۲۰۰ پیامک هدیه</span>
              </div>
              <div class="billing-item">
                <span class="label">طرح ۱۲ ماهه</span>
                <span class="value">۳۵ میلیون</span>
                <span class="hint">+ ۵۰۰۰ پیامک هدیه</span>
              </div>
            </div>
          </div>

          <ul class="features-list">
            <li><span class="key">برند اختصاصی</span><span class="val success">دارد</span></li>
            <li><span class="key">اولویت پشتیبانی</span><span class="val success">اولویت بالا</span></li>
            <li><span class="key">محدودیت کاربر</span><span class="val success">ندارد</span></li>
            <li><span class="key">محدودیت امکانات</span><span class="val success">ندارد</span></li>
            <li><span class="key">پنل پیامکی</span><span class="val success">فعال</span></li>
            <li><span class="key">آپدیت امنیتی</span><span class="val success">فعال</span></li>
            <li><span class="key">آپدیت امکانات</span><span class="val success">فعال</span></li>
            <li><span class="key">انتقال اطلاعات</span><span class="val success">رایگان</span></li>
          </ul>

          <button class="btn btn-main w-100">
            انتخاب طرح حرفه‌ای
          </button>
        </div>
      </div>

    </div>

    <p class="text-center text-muted mt-4 small-note">
      قیمت‌ها به تومان هستند. امکان شخصی‌سازی طرح‌ها و قراردادهای ویژه برای آموزشگاه‌های زنجیره‌ای وجود دارد.
    </p>
  </div>
</section> -->

    <section class="pricing" id="pricing">
      <div class="container">
        <div class="text-center mb-5">
          <span class="section-badge">طرح‌های همکاری</span>
          <h2 class="section-title text-white">راهکار متناسب با سطح رشد آموزشگاه شما</h2>
          <p class="section-subtitle text-light">هر آموزشگاه شرایط و اهداف متفاوتی دارد؛ به همین دلیل قیمت‌گذاری ما کاملاً منعطف و متناسب با نیاز واقعی شما انجام می‌شود.</p>
        </div>

        <div class="row justify-content-center g-4">
          <!-- Economic Plan -->
          <div class="col-lg-5 col-md-6">
            <div class="price-card">
              <div class="plan-header">
                <h3>طرح اقتصادی</h3>
                <p>راه‌اندازی سریع و مقرون‌به‌صرفه برای آموزشگاه‌های در حال رشد</p>
              </div>

              <div class="plan-highlight">مناسب آموزشگاه‌هایی که می‌خواهند با هزینه بهینه، بدون محدودیت کاربر و امکانات، سیستم خود را راه‌اندازی کنند</div>

              <ul class="features-list">
                <li><div class=""></div><span class="key">نصب روی ساب‌دامنه سیستم</span></li>
                <li><div class=""></div><span class="key">دسترسی کامل به امکانات اصلی</span></li>
                <li><div class=""></div><span class="key">پشتیبانی استاندارد</span></li>
                <li><div class=""></div><span class="key">پنل پیامکی فعال</span></li>
                <li><div class=""></div><span class="key">آپدیت امنیتی و امکانات</span></li>
                <li><div class=""></div><span class="key">انتقال اطلاعات رایگان</span></li>
                <li><div class=""></div><span class="key">بدون محدودیت کاربر</span></li>
              </ul>

              <button class="btn btn-price-outline w-100">دریافت مشاوره و استعلام قیمت</button>
            </div>
          </div>

          <!-- Pro Plan -->
          <div class="col-lg-5 col-md-6">
            <div class="price-card featured">
              <div class="featured-badge">پیشنهادی لاجیک</div>

              <div class="plan-header">
                <h3>طرح حرفه ای</h3>
                <p>راهکار اختصاصی برای آموزشگاه‌های برند و چند شعبه‌ای</p>
              </div>

              <div class="plan-highlight">مناسب آموزشگاه‌هایی که به دامنه اختصاصی، بدون محدودیت کاربر ، امکانات و پشتیبانی اولویت‌دار نیاز دارند</div>

              <ul class="features-list">
                <li><div class=""></div><span class="key">نصب روی دامنه اختصاصی آموزشگاه</span></li>
                <li><div class=""></div><span class="key">برند اختصاصی کامل</span></li>
                <li><div class=""></div><span class="key">پشتیبانی با اولویت بالا</span></li>
                <li><div class=""></div><span class="key">بدون محدودیت کاربر</span></li>
                <li><div class=""></div><span class="key">پنل پیامکی فعال</span></li>
                <li><div class=""></div><span class="key">آپدیت امنیتی و امکانات</span></li>
                <li><div class=""></div><span class="key">انتقال اطلاعات رایگان</span></li>
              </ul>

              <button class="btn btn-main w-100">درخواست طرح اختصاصی</button>
            </div>
          </div>
        </div>

        <div class="pricing-note text-center mt-5">
          <p>تعرفه نهایی بر اساس تعداد زبان‌آموزان، شعب، سطح سفارشی‌سازی و نوع راه‌اندازی تعیین می‌شود. برای دریافت پیشنهاد دقیق، با تیم فروش در ارتباط باشید.</p>
        </div>
      </div>
    </section>


        <section class="testimonials-section py-5 bg-light">
      <div class="container">
        <h2 class="mb-4 text-center text-primary fw-bold">کسانی که به ما اعتماد کردند</h2>
        <p class="text-center text-muted mb-5 fs-5">نظر مدیران آموزشگاه‌های معتبر درباره سامانه ما</p>

        <div class="row justify-content-center gy-4">
          <div v-for="(testimonial, index) in testimonials" :key="index" class="col-md-6 col-lg-4 d-flex">
            <div class="card testimonial-card shadow-sm p-4 rounded w-100">
              <p class="testimonial-text mb-3">“{{ testimonial.text }}”</p>
              <div class="d-flex align-items-center">
                <img :src="testimonial.logo" :alt="testimonial.name" class="testimonial-logo me-3" />
                <div>
                  <h5 class="mb-0 testimonial-name">{{ testimonial.name }}</h5>
                  <small class="text-muted testimonial-position">{{ testimonial.position }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- CTA -->

    <!-- SMART CTA (LUXURY VERSION) -->
    <section class="smart-cta-pro">
      <div class="container">
        <div class="cta-grid">
          <!-- TEXT SIDE -->
          <div class="cta-info">
            <h2 class="cta-headline">آموزشگاهت رو <span class="text-gradient">هوشمند</span> کن و وارد نسل جدید آموزش شو 🚀</h2>

            <p class="cta-description">
              سیستم مدیریت آموزشگاه زبان که همه‌چیز رو یکجا برات جمع می‌کنه: از ثبت‌نام آنلاین تا کنترل مالی، از برنامه‌ریزی کلاس‌ها تا گزارش‌های مدیریتی زنده. هیچ اسپردشیتی، هیچ تماسی، هیچ آشفتگی‌ای
              باقی نمی‌مونه.
            </p>

            <p class="cta-highlight">
              <strong>ما معتقدیم هر خط کد، یک تعهد است. در ltwo، ما تعهداتمان را بهینه می‌نویسیم</strong>
            </p>

            <div class="cta-buttons">
              <button class="btn btn-main cta-btn-big">تجربه دموی زنده سیستم 🚀</button>
              <button class="btn btn-price-outline cta-btn-big">ارتباط با تیم مشاوره</button>
            </div>
          </div>

          <!-- VISUAL SIDE -->
          <div class="cta-visual">
            <div class="circle-bg"></div>

            <div class="mock-card mock-main">
              <div class="mock-header"></div>
              <div class="mock-line"></div>
              <div class="mock-line short"></div>
              <div class="mock-block"></div>
            </div>

            <div class="mock-card mock-side"></div>
            <div class="mock-card mock-small"></div>
          </div>
        </div>
      </div>
    </section>



    <!-- FOOTER -->
    <footer class="main-footer">
      <div class="container">
        <div class="row g-5">
          <!-- Brand & About -->
          <div class="col-lg-4 col-md-6">
            <div class="footer-brand">
              <div class="brand-logo">L<span>Two</span>.ir</div>
              <p class="brand-pitch">هوشمندترین راهکار مدیریت آموزشگاه‌های زبان در ایران. ما با ترکیب تکنولوژی و آموزش، مسیر رشد شما را هموار می‌کنیم.</p>
              <div class="social-links">
                <a href="#" class="social-icon">Instagram</a>
                <a href="#" class="social-icon">Telegram</a>
                <a href="#" class="social-icon">بــله</a>
              </div>
            </div>
          </div>

          <!-- Quick Links -->
          <div class="col-lg-2 col-md-6 col-6">
            <h5 class="footer-title">دسترسی سریع</h5>
            <ul class="footer-links">
              <li><a href="#features">قابلیت‌ها</a></li>
              <li><a href="#pricing">راهکارها</a></li>
              <li><a href="#">درخواست دمو</a></li>
              <li><a href="#">سوالات متداول</a></li>
            </ul>
          </div>

          <!-- Resources -->
          <div class="col-lg-2 col-md-6 col-6">
            <h5 class="footer-title">منابع</h5>
            <ul class="footer-links">
              <li><a href="#">وبلاگ آموزشی</a></li>
              <li><a href="#">مستندات سیستم</a></li>
              <li><a href="#">قوانین و مقررات</a></li>
              <li><a href="#">امنیت داده‌ها</a></li>
            </ul>
          </div>

          <!-- Contact Info -->
          <div class="col-lg-4 col-md-6">
            <h5 class="footer-title">ارتباط با ما</h5>
            <ul class="contact-list">
              <li>
                <span class="icon">📍</span>
                اصفهان، برج های دو قلو، طبقه 12، واحد 128
              </li>
              <li>
                <span class="icon">📞</span>
                0921-5476588 (پشتیبانی ۲۴ ساعته)
              </li>
              <li>
                <span class="icon">✉️</span>
                support@LTwo.ir
              </li>
            </ul>
          </div>
        </div>

        <hr class="footer-divider" />

        <div class="footer-bottom">
          <div class="copyright">© ۲۰۲۶ تمامی حقوق برای <strong>تیم لاجیک لاین</strong> محفوظ است. ساخته شده با 💙 برای آموزش ایران.</div>
          <div class="footer-status"><span class="status-dot"></span> تمامی سیستم‌ها عملیاتی هستند</div>
        </div>
      </div>
    </footer>

    <div class="" dir="rtl">
      <BaseModal :show.sync="ShowModal" :icon="iconModal" :size="SizeModal" :title="titleModal" @Close="CloseModal">
        <div class="">
          <h6>جهت مشاوره تلفنی اطلاعات زیر را تکمیل کنید</h6>
          <input type="text" class="form-control text-center mt-4" placeholder=" شماره همراه" dir="ltr">
          <input type="text" class="form-control text-center mt-2" placeholder=" نام آموزشگاه" dir="rtl">
          <textarea class="form-control text-center mt-2" rows="3" placeholder="آدرس"></textarea>
          <textarea class="form-control text-center mt-2" rows="7" placeholder="توضیحات"></textarea>
        </div>
      </BaseModal>
    </div>

  </div>
</template>
<script>
import BaseModal from './component/BaseModal.vue';
export default {
  components:{BaseModal},
  data() {
    return {
      testimonials: [
        {
          name: "آموزشگاه زبان پارسیان",
          position: "مدیر آموزشگاه",
          text: " ما را در مدیریت کامل کلاس‌ها و دانش‌آموزان به طور چشمگیری یاری کرده است.",
          logo: "/logos/parsian.png",
        },
        {
          name: "موسسه زبان ایران",
          position: "مدیر عامل",
          text: "پشتیبانی بی‌نظیر و رابط کاربری ساده این سامانه، باعث افزایش بهره‌وری ما شده است.",
          logo: "/logos/iranlang.png",
        },
        {
          name: " آکادمی زبان پردیس سخن قهدریجان",
          position: "مدیر آموزشگاه",
          text: "بهترین انتخاب برای مدیریت آموزشگاه‌های زبان با قابلیت‌های انعطاف‌پذیر و مقرون به صرفه",
          logo: "/logos/tehranacademy.png",
        },
      ],
      ShowModal:false,
      SizeModal: "xl",
      titleModal: "",
      iconModal: "",
    };
  },
  methods: {
    hoverIn(e) {
      e.target.style.filter = "none";
      e.target.style.transform = "scale(1.05)";
      e.target.style.transition = "all 0.3s ease";
    },
    hoverOut(e) {
      e.target.style.filter = "grayscale(100%) opacity(0.7)";
      e.target.style.transform = "scale(1)";
      e.target.style.transition = "all 0.3s ease";
    },
    MoshaverTell(){
      this.SizeModal = "md";
      this.titleModal = " درخواست مشاوره تلفنی ";
      this.iconModal = "fal fa-headset";
      this.ShowModal=true
    },
    CloseModal() {
      this.ShowModal = false;
    },
  },
};
</script>
<style scoped>
.testimonials-section {
  background-color: #f9fafc;
}
.testimonial-card {
  background: #fff;
  border: 1px solid #ddd;
  transition: box-shadow 0.3s ease;
}
.testimonial-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}
.testimonial-text {
  font-style: italic;
  font-size: 1.1rem;
  color: #333;
  min-height: 100px;
}
.testimonial-logo {
  max-height: 50px;
  width: auto;
}
.testimonial-name {
  font-weight: 600;
  color: #222;
}
.testimonial-position {
  font-size: 0.85rem;
  color: #777;
}
</style>
<style scoped>
/* ===== ROOT ===== */

.landing {
  background: #0b1120;
  color: #fff;
  font-family: IRANSansWeb, Nahid;
  overflow-x: hidden;
}

/* ===== NAVBAR ===== */

.nav-glass {
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
}

.btn-login {
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 8px 22px;
  border-radius: 10px;
  color: #fff;
  transition: 0.3s;
}

.btn-login:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* ===== HERO ===== */

.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  background: radial-gradient(circle at 20% 20%, rgba(99, 102, 241, 0.35), transparent 40%), radial-gradient(circle at 80% 0%, rgba(6, 182, 212, 0.35), transparent 40%), #0b1120;
}

.hero-title {
  font-size: 64px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -1px;
}

.hero-sub {
  max-width: 700px;
  margin: 25px auto;
  opacity: 0.85;
  font-size: 18px;
  line-height: 1.8;
}

.hero-buttons {
  margin-top: 35px;
}

.hero-glow {
  position: absolute;
  width: 600px;
  height: 600px;
  background: #6366f1;
  filter: blur(180px);
  opacity: 0.25;
  top: -200px;
  left: -150px;
}

/* ===== BUTTONS ===== */

.btn-main {
  background: linear-gradient(135deg, #6366f1, #06b6d4);
  border: none;
  padding: 14px 38px;
  border-radius: 14px;
  color: #fff;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 15px 40px rgba(99, 102, 241, 0.4);
}

.btn-main:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 60px rgba(99, 102, 241, 0.6);
}

.btn-outline-main {
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 14px 38px;
  border-radius: 14px;
  color: #fff;
  margin-right: 12px;
  transition: 0.3s;
}

.btn-outline-main:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* ===== DASHBOARD MOCK ===== */

.dashboard {
  padding: 140px 0;
}

.dashboard-card {
  background: #fff;
  color: #111;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 40px 100px rgba(0, 0, 0, 0.45);
  transform: perspective(1000px) rotateX(3deg);
  transition: 0.4s ease;
}

.dashboard-card:hover {
  transform: perspective(1000px) rotateX(0deg);
}

.sidebar {
  background: #f4f4f4;
  padding: 35px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin-top: 20px;
}

.sidebar li {
  margin: 12px 0;
  font-weight: 500;
  color: #444;
}

.stat {
  background: #f9fafb;
  padding: 30px;
  border-radius: 14px;
  text-align: center;
  transition: 0.3s;
}

.stat:hover {
  background: #eef2ff;
  transform: translateY(-4px);
}

.stat h3 {
  font-weight: 800;
  margin-bottom: 5px;
}

/* ===== FEATURES ===== */

.features {
  padding: 140px 0;
  background: #fff;
  color: #111;
}

.section-title {
  text-align: center;
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 70px;
}

.feature-card {
  background: #fff;
  padding: 40px;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgb(0, 0, 0);
  transition: 0.4s ease;
  text-align: center;
  cursor: pointer;
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12);
}

.feature-card h5 {
  font-weight: 700;
  margin-bottom: 15px;
}

/* ===== PRICING ===== */

.pricing {
  padding: 140px 0;
  background: linear-gradient(135deg, #1e293b, #0f172a);
}

.price-card {
  background: #fff;
  color: #111;
  padding: 50px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);
  transition: 0.3s;
}

.price-card:hover {
  transform: scale(1.05);
}

.price-card h2 {
  font-weight: 800;
  margin: 20px 0;
}

.price-card ul {
  list-style: none;
  padding: 0;
  margin: 30px 0;
}

.price-card ul li {
  margin: 12px 0;
}

.price-card.pro {
  border: 3px solid #6366f1;
}

/* ===== CTA ===== */

.cta {
  padding: 140px 0;
  text-align: center;
  background: radial-gradient(circle at 70% 20%, rgba(6, 182, 212, 0.3), transparent 50%), #0b1120;
}

.cta h2 {
  font-weight: 800;
  font-size: 42px;
}

/* ===== FOOTER ===== */

footer {
  padding: 40px;
  text-align: center;
  opacity: 0.6;
  font-size: 14px;
  background: #0b1120;
}
</style>
<style scoped>
/* ===== SECTION HELPERS ===== */

.section-badge {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 14px;
  margin-bottom: 18px;
}

.section-subtitle {
  max-width: 700px;
  margin: 0 auto;
  opacity: 0.8;
  font-size: 15px;
  line-height: 1.9;
}

/* ===== PRICING ===== */

.pricing {
  padding: 120px 0 100px;
  background: radial-gradient(circle at 20% 20%, rgba(99, 102, 241, 0.2), transparent 35%), radial-gradient(circle at 80% 0%, rgba(6, 182, 212, 0.18), transparent 35%),
    linear-gradient(180deg, #0f172a 0%, #020617 100%);
  position: relative;
}

.price-card {
  position: relative;
  height: 100%;
  background: rgba(15, 23, 42, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 24px;
  padding: 26px 24px 24px;
  color: #e5e7eb;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.8);
  transition: all 0.35s ease;
  overflow: hidden;
}

.price-card:hover {
  transform: translateY(-8px);
  border-color: rgba(129, 140, 248, 0.9);
  box-shadow: 0 32px 100px rgba(15, 23, 42, 1);
}

.price-card.featured {
  background: linear-gradient(150deg, rgba(79, 70, 229, 0.35), rgba(15, 23, 42, 0.95));
  border: 1px solid rgba(129, 140, 248, 1);
  box-shadow: 0 32px 110px rgba(79, 70, 229, 0.55);
}

.featured-badge {
  position: absolute;
  top: 18px;
  left: 18px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: linear-gradient(135deg, #6366f1, #06b6d4);
  color: #fff;
  box-shadow: 0 12px 30px rgba(79, 70, 229, 0.6);
}

/* header */

.plan-header h3 {
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 6px;
}

.plan-header p {
  font-size: 13px;
  opacity: 0.8;
  margin-bottom: 18px;
}

/* price main */

.price-main {
  background: rgba(15, 23, 42, 0.8);
  border-radius: 18px;
  padding: 14px 14px 10px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  margin-bottom: 18px;
}

.setup-cost {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.setup-cost .label {
  font-size: 13px;
  opacity: 0.85;
}

.setup-cost .value {
  font-weight: 800;
  font-size: 16px;
  color: #e5e7eb;
}

/* billing options */

.billing-options {
  border-top: 1px dashed rgba(148, 163, 184, 0.5);
  padding-top: 10px;
  margin-top: 4px;
}

.billing-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 6px;
}

.billing-item .label {
  font-size: 12px;
  opacity: 0.85;
}

.billing-item .value {
  font-size: 14px;
  font-weight: 600;
}

.billing-item .hint {
  font-size: 11px;
  color: #a5b4fc;
}

/* feature list */

.features-list {
  list-style: none;
  padding: 0;
  margin: 10px 0 18px 0;
}

.features-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px dashed rgba(148, 163, 184, 0.4);
  font-size: 13px;
}

.features-list li:last-child {
  border-bottom: none;
}

.features-list .key {
  opacity: 0.9;
}

.features-list .val {
  font-weight: 600;
}

.features-list .val.muted {
  opacity: 0.6;
}

.features-list .val.success {
  color: #4ade80;
}

/* buttons */

.btn-price-outline {
  background: transparent;
  border: 1px solid rgba(148, 163, 184, 0.8);
  color: #e5e7eb;
  padding: 11px 18px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 14px;
  transition: 0.3s;
}

.btn-price-outline:hover {
  background: rgba(148, 163, 184, 0.12);
  border-color: #e5e7eb;
  color: #fff;
}

/* note */

.small-note {
  opacity: 0.7;
  font-size: 12px;
}
</style>
<style scoped>
/* ===== FEATURES ===== */

.features {
  padding: 120px 0;
  /* background:
    radial-gradient(circle at 80% 20%, rgba(6,182,212,.15), transparent 40%),
    linear-gradient(180deg, #020617 0%, #0f172a 100%); */
}

.feature-card {
  height: 100%;
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 22px;
  padding: 26px 24px;
  box-shadow: 0 18px 60px rgba(15, 23, 42, 0.363);
  transition: all 0.35s ease;
  color: #e5e7eb;
}

.feature-card:hover {
  transform: translateY(-8px);
  /* border-color:rgba(214, 145, 40, 0.9); */
  box-shadow: 0 30px 90px rgba(15, 23, 42, 1);
}

.feature-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #6366f1, #06b6d4);
  box-shadow: 0 14px 40px rgba(99, 102, 241, 0.55);
}

.feature-card h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}

.feature-card p {
  font-size: 14px;
  line-height: 1.9;
  opacity: 0.85;
}
</style>
<style scoped>
/* ===== SHARP CTA STYLES ===== */

.smart-cta-pro {
  position: relative;
  overflow: hidden;
  padding: 160px 0;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #020617 100%);
}

.smart-cta-pro::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 10% 80%, rgba(99, 102, 241, 0.25), transparent 45%), radial-gradient(circle at 70% 20%, rgba(6, 182, 212, 0.18), transparent 30%);
  opacity: 1;
  z-index: 0;
}

.cta-grid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
  gap: 60px;
}

.cta-info {
  flex: 1 1 480px;
  color: #e5e7eb;
}

.cta-headline {
  font-size: 38px;
  font-weight: 900;
  line-height: 1.4;
  margin-bottom: 20px;
  color: #fff;
}

.text-gradient {
  background: linear-gradient(120deg, #6366f1, #06b6d4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.cta-description {
  font-size: 16px;
  opacity: 0.9;
  line-height: 2;
  margin-bottom: 18px;
}

.cta-highlight {
  font-size: 15px;
  color: #c7d2fe;
  line-height: 1.8;
  margin-bottom: 32px;
  direction: rtl;
}

.cta-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.cta-btn-big {
  padding: 14px 30px !important;
  font-size: 15px;
  border-radius: 14px;
}

/* Visual mock side */

.cta-visual {
  flex: 1 1 420px;
  position: relative;
  min-height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-bg {
  position: absolute;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.3), transparent 70%);
  filter: blur(40px);
  animation: pulse 10s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}

.mock-card {
  position: absolute;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: float 7s ease-in-out infinite;
}

.mock-main {
  width: 280px;
  height: 180px;
  z-index: 3;
  animation-delay: 0s;
}

.mock-side {
  width: 160px;
  height: 120px;
  top: 10%;
  left: 10%;
  animation-delay: 1.2s;
}

.mock-small {
  width: 140px;
  height: 90px;
  bottom: 8%;
  right: 12%;
  animation-delay: 2.1s;
}

.mock-header {
  width: 100%;
  height: 36px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 16px 16px 0 0;
}

.mock-line {
  height: 8px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  margin: 12px 20px;
  width: 80%;
}

.mock-line.short {
  width: 50%;
  margin-top: -4px;
}

.mock-block {
  width: 120px;
  height: 60px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  margin: 10px 20px;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
<style scoped>
/* ===== MAIN FOOTER ===== */

.main-footer {
  background: #020617;
  padding: 80px 0 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
}

.footer-brand .brand-logo {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 20px;
}
.footer-brand1 .brand-logo {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
}
.footer-brand1 .brand-logo span {
  color: #6366f1;
}
.footer-brand .brand-logo span {
  color: #6366f1;
}

.brand-pitch {
  font-size: 14px;
  line-height: 1.8;
  opacity: 0.7;
  color: #e5e7eb;
  margin-bottom: 25px;
}

/* Socials */
.social-links {
  display: flex;
  gap: 12px;
}

.social-icon {
  font-size: 12px;
  color: #94a3b8;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: 0.3s;
}

.social-icon:hover {
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
  border-color: #6366f1;
}

/* Titles & Links */
.footer-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 25px;
  position: relative;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #94a3b8;
  text-decoration: none;
  font-size: 14px;
  transition: 0.3s;
}

.footer-links a:hover {
  color: #6366f1;
  padding-right: 5px;
}

/* Contact List */
.contact-list {
  list-style: none;
  padding: 0;
}

.contact-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #94a3b8;
  font-size: 14px;
  margin-bottom: 15px;
  line-height: 1.6;
}

.contact-list .icon {
  font-size: 18px;
}

/* Bottom Bar */
.footer-divider {
  margin: 50px 0 30px;
  border-color: rgba(255, 255, 255, 0.05);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  color: #64748b;
  font-size: 13px;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #22c55e;
  border-radius: 50%;
  margin-left: 5px;
  box-shadow: 0 0 10px rgba(34, 197, 94, 0.5);
}
</style>
